/*
 * Automatically generated by codegen/smith.ts.
 * Do not edit this file or add other files to this directory.
 */
import { seamApiLtsVersion } from '../../../../../../lib/lts-version.js';
import { getAuthHeadersForClientSessionToken, warnOnInsecureuserIdentifierKey, } from '../../../../../../lib/seam/connect/auth.js';
import { createClient } from '../../../../../../lib/seam/connect/client.js';
import { isSeamHttpOptionsWithApiKey, isSeamHttpOptionsWithClient, isSeamHttpOptionsWithClientSessionToken, isSeamHttpOptionsWithConsoleSessionToken, isSeamHttpOptionsWithPersonalAccessToken, SeamHttpInvalidOptionsError, } from '../../../../../../lib/seam/connect/options.js';
import { limitToSeamHttpRequestOptions, parseOptions, } from '../../../../../../lib/seam/connect/parse-options.js';
import { SeamHttpClientSessions } from '../../../../../../lib/seam/connect/routes/client-sessions/index.js';
import { SeamHttpRequest } from '../../../../../../lib/seam/connect/seam-http-request.js';
import { SeamPaginator } from '../../../../../../lib/seam/connect/seam-paginator.js';
import { SeamHttpAcsUsersUnmanaged } from './unmanaged/index.js';
export class SeamHttpAcsUsers {
    client;
    defaults;
    ltsVersion = seamApiLtsVersion;
    static ltsVersion = seamApiLtsVersion;
    constructor(apiKeyOrOptions = {}) {
        const options = parseOptions(apiKeyOrOptions);
        this.client = 'client' in options ? options.client : createClient(options);
        this.defaults = limitToSeamHttpRequestOptions(options);
    }
    static fromClient(client, options = {}) {
        const constructorOptions = { ...options, client };
        if (!isSeamHttpOptionsWithClient(constructorOptions)) {
            throw new SeamHttpInvalidOptionsError('Missing client');
        }
        return new SeamHttpAcsUsers(constructorOptions);
    }
    static fromApiKey(apiKey, options = {}) {
        const constructorOptions = { ...options, apiKey };
        if (!isSeamHttpOptionsWithApiKey(constructorOptions)) {
            throw new SeamHttpInvalidOptionsError('Missing apiKey');
        }
        return new SeamHttpAcsUsers(constructorOptions);
    }
    static fromClientSessionToken(clientSessionToken, options = {}) {
        const constructorOptions = { ...options, clientSessionToken };
        if (!isSeamHttpOptionsWithClientSessionToken(constructorOptions)) {
            throw new SeamHttpInvalidOptionsError('Missing clientSessionToken');
        }
        return new SeamHttpAcsUsers(constructorOptions);
    }
    static async fromPublishableKey(publishableKey, userIdentifierKey, options = {}) {
        warnOnInsecureuserIdentifierKey(userIdentifierKey);
        const clientOptions = parseOptions({ ...options, publishableKey });
        if (isSeamHttpOptionsWithClient(clientOptions)) {
            throw new SeamHttpInvalidOptionsError('The client option cannot be used with SeamHttpAcsUsers.fromPublishableKey');
        }
        const client = createClient(clientOptions);
        const clientSessions = SeamHttpClientSessions.fromClient(client);
        const { token } = await clientSessions.getOrCreate({
            user_identifier_key: userIdentifierKey,
        });
        return SeamHttpAcsUsers.fromClientSessionToken(token, options);
    }
    static fromConsoleSessionToken(consoleSessionToken, workspaceId, options = {}) {
        const constructorOptions = { ...options, consoleSessionToken, workspaceId };
        if (!isSeamHttpOptionsWithConsoleSessionToken(constructorOptions)) {
            throw new SeamHttpInvalidOptionsError('Missing consoleSessionToken or workspaceId');
        }
        return new SeamHttpAcsUsers(constructorOptions);
    }
    static fromPersonalAccessToken(personalAccessToken, workspaceId, options = {}) {
        const constructorOptions = { ...options, personalAccessToken, workspaceId };
        if (!isSeamHttpOptionsWithPersonalAccessToken(constructorOptions)) {
            throw new SeamHttpInvalidOptionsError('Missing personalAccessToken or workspaceId');
        }
        return new SeamHttpAcsUsers(constructorOptions);
    }
    createPaginator(request) {
        return new SeamPaginator(this, request);
    }
    async updateClientSessionToken(clientSessionToken) {
        const { headers } = this.client.defaults;
        const authHeaders = getAuthHeadersForClientSessionToken({
            clientSessionToken,
        });
        for (const key of Object.keys(authHeaders)) {
            if (headers[key] == null) {
                throw new Error('Cannot update a clientSessionToken on a client created without a clientSessionToken');
            }
        }
        this.client.defaults.headers = { ...headers, ...authHeaders };
        const clientSessions = SeamHttpClientSessions.fromClient(this.client);
        await clientSessions.get();
    }
    get unmanaged() {
        return SeamHttpAcsUsersUnmanaged.fromClient(this.client, this.defaults);
    }
    addToAccessGroup(parameters, options = {}) {
        return new SeamHttpRequest(this, {
            pathname: '/acs/users/add_to_access_group',
            method: 'PUT',
            body: parameters,
            responseKey: undefined,
            options,
        });
    }
    create(parameters, options = {}) {
        return new SeamHttpRequest(this, {
            pathname: '/acs/users/create',
            method: 'POST',
            body: parameters,
            responseKey: 'acs_user',
            options,
        });
    }
    delete(parameters, options = {}) {
        return new SeamHttpRequest(this, {
            pathname: '/acs/users/delete',
            method: 'POST',
            body: parameters,
            responseKey: undefined,
            options,
        });
    }
    get(parameters, options = {}) {
        return new SeamHttpRequest(this, {
            pathname: '/acs/users/get',
            method: 'POST',
            body: parameters,
            responseKey: 'acs_user',
            options,
        });
    }
    list(parameters, options = {}) {
        return new SeamHttpRequest(this, {
            pathname: '/acs/users/list',
            method: 'POST',
            body: parameters,
            responseKey: 'acs_users',
            options,
        });
    }
    listAccessibleEntrances(parameters, options = {}) {
        return new SeamHttpRequest(this, {
            pathname: '/acs/users/list_accessible_entrances',
            method: 'POST',
            body: parameters,
            responseKey: 'acs_entrances',
            options,
        });
    }
    removeFromAccessGroup(parameters, options = {}) {
        return new SeamHttpRequest(this, {
            pathname: '/acs/users/remove_from_access_group',
            method: 'POST',
            body: parameters,
            responseKey: undefined,
            options,
        });
    }
    revokeAccessToAllEntrances(parameters, options = {}) {
        return new SeamHttpRequest(this, {
            pathname: '/acs/users/revoke_access_to_all_entrances',
            method: 'POST',
            body: parameters,
            responseKey: undefined,
            options,
        });
    }
    suspend(parameters, options = {}) {
        return new SeamHttpRequest(this, {
            pathname: '/acs/users/suspend',
            method: 'POST',
            body: parameters,
            responseKey: undefined,
            options,
        });
    }
    unsuspend(parameters, options = {}) {
        return new SeamHttpRequest(this, {
            pathname: '/acs/users/unsuspend',
            method: 'POST',
            body: parameters,
            responseKey: undefined,
            options,
        });
    }
    update(parameters, options = {}) {
        return new SeamHttpRequest(this, {
            pathname: '/acs/users/update',
            method: 'PATCH',
            body: parameters,
            responseKey: undefined,
            options,
        });
    }
}
//# sourceMappingURL=users.js.map